// 异常排查-NEW
import React, { useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AbnormalTable from './abnormalTable'
import AnomalouInfo from './anomalouInfo'

function AbnormalTroubleshooting () {
  const [showMain, setShowMain] = useState(true)//展示主页
  const [tableInfo, setTableInfo] = useState(true)//展示主页

  useEffect(() => {
  }, [])

  //在table中传信息到index中
  const getInfoByTable = (obj) => {
    setShowMain(obj.showMain)
    setTableInfo({ ...obj })
  }

  // 在info中返回table
  const getShow = (isShow) => {
    setShowMain(isShow)
  }
  return (
    <div>
      {/* <span style={{ color: '#fff' }}>{showMain ? `true` : `false`}</span> */}
      {
        showMain
          ? <AbnormalTable getInfo={getInfoByTable}></AbnormalTable>
          : <AnomalouInfo getShow={getShow} tableInfo={tableInfo}></AnomalouInfo>
      }
    </div>
  )
}
export default AbnormalTroubleshooting